<div class="text-info__text">
  @if (title && useLargeHeading) {
    <h1 class="text-info__text__title" [bindHTML]="title"></h1>
  } @else {
    <h2 class="text-info__text__title" [bindHTML]="title"></h2>
  }

  @if (!title && subtitle && useLargeHeading) {
    <h2 class="text-info__text__title" [bindHTML]="subtitle"></h2>
  } @else {
    <h3 class="text-info__text__subtitle" [bindHTML]="subtitle"></h3>
  }

  @if (description) {
    <div class="text-info__text__description" [bindHTML]="description"></div>
  }
</div>
